import React from 'react';

import ParagraphProduct from './Default';
import ParagraphProductGetStarted from './GetStarted';

const Video = (props) => {
  const { viewMode } = props;

  if (viewMode === 'getStarted') {
    return <ParagraphProductGetStarted {...props} />;
  }

  return <ParagraphProduct {...props} />;
};

export default Video;
